import React, { useLayoutEffect } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { ViewPage as Component, type ViewPageProps as Props } from './ViewPage';
import { PageNotFoundEmptyState } from '../empty-state';
import { I18nProvider } from '../i18n/I18nProvider';
import fetchTranslations from '../i18n/fetchTranslations';
import { usePerformanceMetrics } from '../performance-metrics/performanceMetricsProvider';
import { UniqueKeyProvider } from '../unique-key-provider/UniqueKeyProvider';

export type ViewPageProps = Props & { locale?: string };

// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export const ViewPage = (props: ViewPageProps): React.JSX.Element => {
	const { markIframeLoadMetrics } = usePerformanceMetrics();

	useLayoutEffect(() => {
		markIframeLoadMetrics('lazy-load-end');
		markIframeLoadMetrics('common-load-start');
	}, [markIframeLoadMetrics]);

	return (
		<I18nProvider locale={props.locale} fetchTranslations={fetchTranslations}>
			<UniqueKeyProvider>
				<ErrorBoundary fallback={<PageNotFoundEmptyState />}>
					<Component {...props} />
				</ErrorBoundary>
			</UniqueKeyProvider>
		</I18nProvider>
	);
};
